import extend from 'mdui.jq/es/functions/extend';
import stateDefault from './stateDefault';
/**
 * 在需要用到编辑器的页面中，引入该 state
 */

export default extend({}, stateDefault);